import { Modal } from "antd";
import React from "react";

const ImagePreviewModal = ({
  visible,
  imageSrc,
  onClose,
  zIndex,
  getContainer,
}) => {
  return (
    <Modal
      visible={visible}
      footer={null}
      onCancel={onClose}
      centered
      title="Image Preview"
      bodyStyle={{ padding: "16px", textAlign: "center" }}
      zIndex={zIndex}
      getContainer={getContainer}
    >
      {imageSrc && (
        <img
          src={imageSrc}
          alt="Full Preview"
          style={{
            width: "100%",
            maxHeight: "70vh",
            objectFit: "contain",
            borderRadius: 4,
          }}
        />
      )}
    </Modal>
  );
};

export default ImagePreviewModal;
